module.exports = __webpack_public_path__ + "img/blueberry-pie.6a48c0e2.jpg";